import { z } from "zod";

const BrowseTargetFieldsSchema = z.object({}).strict();

export default BrowseTargetFieldsSchema;
